module.exports = __webpack_public_path__ + "img/search-module.73e9835c.png";